import type { ReactElement } from 'react';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { useProjectViewWorkflowService } from './use-project-view-workflow-service/main.tsx';

type IssueKey = string;
type IssueTypeId = string;

type WorkflowServiceData = {
	hasPermission?: boolean;
	issueTypeId?: IssueTypeId;
	projectId?: string | undefined;
	projectType?: ProjectType | undefined;
	isSimplified?: boolean | undefined;
};

export type ServiceApi = {
	data: WorkflowServiceData | undefined;
	loading: boolean;
	error: FetchError | undefined;
	fetch: () => Promise<void>;
};

export type Props = {
	issueKey: IssueKey;
	children: (arg1: ServiceApi) => ReactElement;
};

export const emptyResult: ServiceApi = {
	data: undefined,
	loading: false,
	error: undefined,
	fetch: () => Promise.resolve(),
};

/**
 * Gets projectData from ContainerContextSubscriber or from service
 */
const ViewWorkflowContextService = (props: Props) => {
	const { issueKey, children } = props;

	return children(useProjectViewWorkflowService(issueKey));
};

export default ViewWorkflowContextService;
